<template>
  <div class="fill-height">
    <v-card
        height="100%"
        class="rounded-lg"
    >
      <div class="d-flex justify-space-between align-center">
        <v-card-title class="text-break link-on-hover" @click.prevent="goToBestChoices()"><strong>{{ $t('cards.titles.bestChoices') }} ></strong></v-card-title>
        <v-btn
            v-if="!$vuetify.breakpoint.mobile"
            text
            color="primary"
            class="mx-4"
            @click.prevent="goToBestChoices()"
        >
          {{ $t('buttons.showAll') }}
          <v-icon
              right
              dark
          >
            fal fa-chevron-right
          </v-icon>
        </v-btn>
      </div>
      <v-card-text v-if="isLoading" class="d-flex justify-start flex-wrap">
        <template v-for="n in 4">
            <div class="col-12 col-sm-6 col-lg-3 ma-0 pa-2" :key="n">
              <v-card
                  class="ma-2 my-0 rounded-lg"
                  color="transparent"
                  flat
              >
                <v-skeleton-loader
                    type="image"
                ></v-skeleton-loader>
              </v-card>
            </div>
          </template>
      </v-card-text>
      <v-card-text v-if="!isLoading && !children" class="d-flex justify-center align-center">
        <div class="my-6 fill-height">{{ $t('cards.texts.comingSoon') }}</div>
      </v-card-text>
      <!--<v-card-text v-if="!isLoading" class="px-2 py-0 d-flex flex-wrap">
        <template v-for="(serie, n) in series.collections">
          <div :key="'bestChoice-' + serie.id" class="col-12 col-sm-6 col-lg-3 pa-0 px-2" v-if="n < 4">
            <v-card
                class="ma-2 my-0"
                color="transparent"
                flat
                tile
                height="100%"
                link
            >
              <v-hover v-slot="{ hover }">
                <v-img
                    :src="serie.thumbnail"
                    @click.prevent="goToCollection(serie)"
                >
                  <v-chip
                      v-if="serie.duration && serie.type === 'video'"
                      class="ma-2 rounded-lg"
                      label
                      small
                      color="primary"
                  >
                    {{ serie.duration.formatted.substring(0, 3) === '00:' ? serie.duration.formatted.substring(3) : serie.duration.formatted }}
                  </v-chip>
                  <v-fade-transition v-if="serie.type === 'video' && hover">
                    <v-overlay
                        v-if="hover"
                        absolute
                        color="black"
                    >
                      <v-icon
                          color="primary"
                          large
                      >
                        fas fa-play
                      </v-icon>
                    </v-overlay>
                  </v-fade-transition>
                </v-img>
              </v-hover>
              <v-card-text class="d-flex justify-space-between align-start">
                <div>
                  <div v-if="serie.name" @click.prevent="goToCollection(serie)"><strong>{{ serie.name }}</strong></div>
                  <div v-if="serie.type === 'video' && serie.episodeNumber">{{ $t('labels.episode') }} {{ serie.episodeNumber }}</div>
                  <div v-if="serie.type === 'file' && serie.size">{{ serie.size.formatted }}</div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </template>
      </v-card-text>-->
      <v-card-text v-if="!isLoading" class="px-2 py-0 d-flex flex-wrap">
            <template v-for="(child, n) in children">
                <div :key="'bestChoice-' + child.identifier" class="col-12 col-sm-6 col-lg-3 pa-0 px-2" v-if="n < 4">
                    <v-card
                            class="ma-2 my-0"
                            color="transparent"
                            flat
                            tile
                            height="100%"
                            link
                            @click.prevent="navigate('/content/' + child.identifier)"
                    >
                        <v-hover v-slot="{ hover }">
                            <v-img
                                    :src="child.asset.properties.thumbnailUrl"
                            >
                                <!--<v-chip
                                        v-if="serie.duration && serie.type === 'video'"
                                        class="ma-2 rounded-lg"
                                        label
                                        small
                                        color="primary"
                                >
                                    {{ serie.duration.formatted.substring(0, 3) === '00:' ? serie.duration.formatted.substring(3) : serie.duration.formatted }}
                                </v-chip>-->
                                <v-fade-transition v-if="child.asset.system === 'VIMEO' && hover">
                                    <v-overlay
                                            v-if="hover"
                                            absolute
                                            color="black"
                                    >
                                        <v-icon
                                                color="primary"
                                                large
                                        >
                                            fas fa-play
                                        </v-icon>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>
                        </v-hover>
                        <v-card-text class="d-flex justify-space-between align-start">
                            <div>
                                <div v-if="child.asset.properties.title"><strong>{{ child.asset.properties.title }}</strong></div>
                                <!--<div v-if="serie.type === 'video' && serie.episodeNumber">{{ $t('labels.episode') }} {{ serie.episodeNumber }}</div>
                                <div v-if="serie.type === 'file' && serie.size">{{ serie.size.formatted }}</div>-->
                            </div>
                        </v-card-text>
                    </v-card>
                </div>
            </template>
      </v-card-text>
      
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-best-choices",
  data() {
    return {
      isLoading: false,
      model: null,
      collectionDetails: {},
      series: [],
      spotlight: [],
      structure: {},
      children: []
    }
  },

  mounted(){
    this.fetchSpotlight()
    // 803217 JANUARI SPOTLIGHT
    // this.fetchCollectionDetails(817741)
    // this.fetchSeries(817741)
  },

  methods: {
    async fetchSpotlight(){
      this.isLoading = true
      let spotlight = []
      spotlight = await api.newsItems.getList("spotlight", this.$i18n.locale).then((res) => { return res.data })
      if (spotlight.length){
        this.spotlight = spotlight.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        if (this.spotlight[0] && this.spotlight[0].properties && this.spotlight[0].properties['spotlightId']){
          /*await this.fetchCollectionDetails(this.spotlight[0].properties['spotlightId'])
          await this.fetchSeries(this.spotlight[0].properties['spotlightId'])*/
            await this.fetchStructure(this.spotlight[0].properties['spotlightId'])
            await this.fetchStructureChildren(this.spotlight[0].properties['spotlightId'])
        }
      }
      this.isLoading = false
    },
      
    async fetchStructure(id){
        this.isLoading = true
        let structure = await api.structures.getStructureById(id).then((res) => { return res.data })
        if (structure){ 
            this.structure = structure
        }
        this.isLoading = false
    },

    async fetchStructureChildren(id){
        this.isLoading = true
        let children = await api.structures.getStructureChildrenById(id).then((res) => { return res.data })
        if (children){ 
            this.children = children.sort((a, b) => { return a.order - b.order })
        }
        this.isLoading = false
    },
    
    async fetchSeries(id){
      this.isLoading = true
      let series = await api.watch.getSeries(id).then((res) => { return res.data })
      if (series){
        this.series = series
      }
      this.isLoading = false
    },
    
    async fetchCollectionDetails(id){
      let collectionDetails = await api.watch.getCategoryDetails(id).then((res) => { return res.data })
      if (collectionDetails){
        this.collectionDetails = collectionDetails
      }
    },

    goToCollection(serie){
      if (serie.type === 'category'){ this.navigate("/browse/" + serie.id) }
      if (serie.type === 'series'){ this.navigate("/series/" + serie.id) }
      if (serie.type === 'file'){ window.open(serie['_links'].source.href, '_blank') }
      /*if (serie.type === 'video'){ this.fetchMovie(serie.id) }*/
      if (serie.type === 'video'){ this.navigate("/videos/" + serie.id) }
    },
      
    goToBestChoices(){
      if (this.spotlight.length && this.spotlight[0].properties['spotlightId']){
          this.navigate('/content/' + this.spotlight[0].properties['spotlightId'])
      }
    },
    
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
  }
}
</script>

<style scoped>

</style>
